// extracted by mini-css-extract-plugin
export const caseStudyTileStyles = "caseStudyTiles-module--caseStudyTileStyles--25XWZ";
export const gridHeadlineStyle = "caseStudyTiles-module--gridHeadlineStyle--3wBRx";
export const featuredTileStyle = "caseStudyTiles-module--featuredTileStyle--3VBPQ";